/**
 * A quien va dirigida la cotizacion: lo que sale en "FACTURADO A" del PDF.
 * Solo el nombre es obligatorio; lo que quede vacio no se imprime.
 */
import { useId } from 'react';

import { formatearRut } from '../../utilidades/rut';

export interface ValoresCliente {
  nombre: string;
  rut: string;
  contacto: string;
  telefono: string;
  email: string;
}

export interface CamposClienteCotizacionProps {
  valores: ValoresCliente;
  onCambiar(campo: keyof ValoresCliente, valor: string): void;
}

export function CamposClienteCotizacion({ valores, onCambiar }: CamposClienteCotizacionProps) {
  const id = useId();

  return (
    <>
      <div className="campos-dos">
        <div className="campo">
          <label htmlFor={`${id}-nombre`}>Cliente</label>
          <input
            id={`${id}-nombre`}
            value={valores.nombre}
            onChange={(evento) => {
              onCambiar('nombre', evento.target.value);
            }}
            required
            maxLength={160}
          />
          <p className="ayuda-campo">Persona, empresa o institución.</p>
        </div>
        <div className="campo">
          <label htmlFor={`${id}-rut`}>RUT</label>
          <input
            id={`${id}-rut`}
            value={valores.rut}
            onChange={(evento) => {
              onCambiar('rut', evento.target.value);
            }}
            onBlur={() => {
              if (valores.rut.trim() !== '') onCambiar('rut', formatearRut(valores.rut));
            }}
            maxLength={15}
            placeholder="Opcional"
          />
        </div>
      </div>

      <div className="campos-tres">
        <div className="campo">
          <label htmlFor={`${id}-contacto`}>Contacto</label>
          <input
            id={`${id}-contacto`}
            value={valores.contacto}
            onChange={(evento) => {
              onCambiar('contacto', evento.target.value);
            }}
            maxLength={120}
            placeholder="Opcional"
          />
        </div>
        <div className="campo">
          <label htmlFor={`${id}-telefono`}>Teléfono</label>
          <input
            id={`${id}-telefono`}
            type="tel"
            value={valores.telefono}
            onChange={(evento) => {
              onCambiar('telefono', evento.target.value);
            }}
            maxLength={30}
            placeholder="Opcional"
          />
        </div>
        <div className="campo">
          <label htmlFor={`${id}-email`}>Correo</label>
          <input
            id={`${id}-email`}
            type="email"
            value={valores.email}
            onChange={(evento) => {
              onCambiar('email', evento.target.value);
            }}
            maxLength={160}
            placeholder="Opcional"
          />
        </div>
      </div>
    </>
  );
}
